import React, { Component } from "react";
import { Text } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import TldrChakraSlider from "../../common/TldrChakraSlider";

class TLDRDownloadImageScale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSizeScale: 1,
    };
  }

  render() {
    const { imageSize, contentSize } = this.props;
    const { imageSizeScale } = this.state;
    const { t } = this.props;

    return contentSize && imageSize ? (
      <>
        <Text fontSize="xs" casing="uppercase" mb={2} mt={2}>
          {t("image_scale_text", {
            img_size: `${contentSize.width * imageSizeScale}px x ${
              contentSize.height * imageSizeScale
            }px`,
          })}
        </Text>
        <TldrChakraSlider
          domain={[1, 5]}
          onChange={this.onChange}
          values={imageSize}
          showDecimals={false}
          unit="x"
          variant="solid"
        />
      </>
    ) : null;
  }

  onChange = (value) => {
    this.props.onImageSizeChange(value);
    this.setState({
      imageSizeScale: value,
    });
  };
}

TLDRDownloadImageScale.propTypes = {};

export default withTranslation(["navbar"])(TLDRDownloadImageScale);
